import { render, staticRenderFns } from "./IconLinkBtn.vue?vue&type=template&id=62af8712"
import script from "./IconLinkBtn.vue?vue&type=script&lang=js"
export * from "./IconLinkBtn.vue?vue&type=script&lang=js"
import style0 from "./IconLinkBtn.vue?vue&type=style&index=0&id=62af8712&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports